import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';
import { format } from 'date-fns';

export const DATE_INPUT_FORMAT = 'yyyy.MM.dd';

export const TIME_INPUT_FORMAT = 'HH:mm';

export const DateFormats: MatDateFormats = {
	parse: {
		dateInput: DATE_INPUT_FORMAT,
		timeInput: TIME_INPUT_FORMAT,
	},
	display: {
		dateInput: DATE_INPUT_FORMAT, // 'input',
		monthYearLabel: 'monthYearLabel',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'yyyy. MM.',
		timeInput: TIME_INPUT_FORMAT,
		timeOptionLabel: TIME_INPUT_FORMAT,
	},
};

export class HunDateAdapter extends NativeDateAdapter {
	override parse(value: string) {
		// safari can't parse "YYYY.MM.DD" format (with dot separator)
		value = value.replace(/\./g, '-');

		const maybeParsed = super.parse(value);

		// if the value is parsable normally return it early
		if (maybeParsed?.toString() !== 'Invalid Date') {
			return maybeParsed;
		}

		// make sure the value is a string (for type safety)
		if (typeof value === 'string') {
			const match = value.match(/^(\d{4})(\d{2})(\d{2})$/);

			// if it's not a 8 character long numeric then return with the original result
			if (!match) return maybeParsed;

			// build the date
			return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
		} else {
			// return with the original result ("Invalid Date" most likely)
			return maybeParsed;
		}
	}

	override format(date: Date, displayFormat: string): string {
		if (displayFormat === 'monthYearLabel') {
			const month = date.getMonth();
			const year = date.getFullYear();
			return `${year}.  ${this.getMonthNames('short')[month]}`;
		} else {
			return format(date, displayFormat);
		}
	}

	override getFirstDayOfWeek(): number {
		return 1;
	}
}
